import React, {useEffect, useState} from 'react';
import styles from './index.module.less';
import {Alignment, Button, Classes, Navbar, NavbarDivider, NavbarGroup, NavbarHeading} from "@blueprintjs/core";
import {useDebounce, useSize} from "@umijs/hooks";
import { useHistory, useLocation } from 'react-router-dom';
import {useSelector} from "react-redux";
import classes from 'classnames';
import ReactTooltip from "react-tooltip";

const BaseLayout = ({ children }) => {
  const [navHidden, setNavHidden] = useState(false);
  const [containerSize, containerRef] = useSize();
  const [headerSize, headerRef] = useSize();
  const [mainHeight, setMainHeight] = useState(0);
  const containerHeight = useDebounce(containerSize.height, 100);
  const headerHeight = useDebounce(headerSize.height, 100);
  const userInfo = useSelector(state => state.userInfo);
  const history = useHistory();
  const location = useLocation();
  useEffect(() => {
    setMainHeight(Number(containerHeight || 0) - Number(headerHeight || 0));
  }, [containerHeight, headerHeight, navHidden]);
  useEffect(() => {
    let hidden = false;
    if (
      location.pathname === '/login' ||
      location.pathname === '/account-login' ||
      location.pathname === '/permission-denied' ||
      location.pathname === '/exchange-course' ||
      location.pathname === '/example' ||
      location.pathname === '/part-finished' ||
      /\/(share|sales)\/[a-zA-z0-9]+/.test(location.pathname)
    ) {
      hidden = true;
    }
    setNavHidden(hidden);
  }, [location.pathname]);

  return (
    <div className={styles['base-layout']} ref={containerRef}>
      <header ref={headerRef} style={{ display: navHidden && 'none' }}>
        <Navbar>
          <NavbarGroup align={Alignment.LEFT}>
            <NavbarHeading>
              <div className={styles.logo} />
            </NavbarHeading>
            <NavbarDivider />
            <Button onClick={() => history.push('/')} className={Classes.MINIMAL} icon='list-detail-view'>课程目录</Button>
            <Button onClick={() => window.open('http://www.pythontip.com/coding/code_oj', '_blank')} className={Classes.MINIMAL} icon='heat-grid'>Python题库</Button>
          </NavbarGroup>
          <NavbarGroup align={Alignment.RIGHT}>
            <span className={classes(Classes.TEXT_MUTED)}>{userInfo.timeSlot}好，{userInfo.userName}</span>
          </NavbarGroup>
        </Navbar>
      </header>
      <main style={{ height: mainHeight }}>
        {children}
      </main>
      <ReactTooltip />
    </div>
  );
};

export default BaseLayout;
